import api from '@/api';

const state = {
  iconos: [],
  loading: false,
  error: null,
};

const getters = {
  iconos: (state) => {
    return state.iconos;
  },

  loading: (state) => {
    return state.loading;
  },

  error: (state) => {
    return state.error;
  },

  iconoSources: (state) => {
    return state.iconos.map((icono) => ({ key: icono.CODIGO, url: icono.RUTA }));
  },

  iconoUrlByCodigo: (state) => {
    return new Map(state.iconos.map((icono) => [icono.CODIGO, icono.RUTA]));
  },
};

const mutations = {
  SET_ICONOS(state, iconos) {
    state.iconos = iconos;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchIconos({ commit, state }) {
    if (state.iconos.length) {
      return;
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      const response = await api.icono.getIconos();
      commit('SET_ICONOS', response.data);
    } catch (err) {
      console.error(err);
      commit('SET_ERROR', err.message);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
